import {
  ADDCARDETAILS,
  ADDCARNUMBER,
  ALLCARDETAILS,
  CARNUMFLAG,
  CAR_INS_PRODUCT,
  PREV_INS_LIST,
  QUICKQUOTES,
  QUICKQUOTE_POST_CAR,
  QUICKQUOE_VALUE_CAR,
  PREV_POLICY_DETAIL_CAR,
  ERROR_QUOTES_CAR,
  CREATE_CRPROPOSAL,
  KYC_CRSTATUS,
  POLICY_CRPDF,
  PAYMENT_CRREQUEST,
  BREAKIN_POLICY,
  TRANS_ID_CAR,
} from "../actiontypes/NumCarActiontypes";
// import axiosInCar from "../axios/AxiosInstance";
import axiosInCar from "../axios/AxiosInCar";
export const numCarflagfalse = () => {
  return {
    type: CARNUMFLAG,
  };
};
export const allcardetails = () => {
  return {
    type: ALLCARDETAILS,
  };
};
export const addcarnum = (data) => {
  // console.log(data);
  return {
    type: ADDCARNUMBER,
    payload: data,
  };
};
export const addcardetails = (data) => {
  return {
    type: ADDCARDETAILS,
    payload: data,
  };
};

export const insuranceproduct = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInCar
        .get("insurance_product/4")
        .then(function (response) {
          // console.log(response);
          dispatch(insurance_product_action(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  };
};

export const PreviousinsurerCar = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInCar
        .get("previous_insurer_list")
        .then(function (response) {
          // console.log(response);
          dispatch(previous_insurance_list(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error.message);
          reject(error);
        });
    });
  };
};

// export const getQuickQuotes = (post) => {
//   return (dispatch, getState) => {
//     return new Promise((resolve, reject) => {
//       axiosInCar
//         .post("v1/car_insurance/quickquotes", post)
//         .then(function (response) {
//           // console.log(response);
//           dispatch(previous_insurance_list(response.data.data));
//           resolve(response.data.data);
//         })
//         .catch(function (error) {
//           console.log(error.message);
//           reject(error);
//         });
//     });
//   };
// };
export const financierList = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInCar
        .get("financier_list")
        .then(function (response) {
          // console.log(response);
          //dispatch(insurance_product_action(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error.response);
          reject(error);
        });
    });
  };
};
export function insurance_product_action(devices) {
  return {
    type: CAR_INS_PRODUCT,
    payload: devices,
  };
}

export function previous_insurance_list(devices) {
  return {
    type: PREV_INS_LIST,
    payload: devices,
  };
}

export function quick_quotes(data) {
  return {
    type: QUICKQUOTES,
    payload: data,
  };
}
export function QuickQuote_Post(data) {
  return {
    type: QUICKQUOTE_POST_CAR,
    payload: data,
  };
}
export function quick_quoteValues(data) {
  return {
    type: QUICKQUOE_VALUE_CAR,
    payload: data,
  };
}
export function Err_quotes(data) {
  return {
    type: ERROR_QUOTES_CAR,
    payload: data,
  };
}
export function BreakIN_quotes(data) {
  return {
    type: BREAKIN_POLICY,
    payload: data,
  };
}
export function GetPrevPolicy(data) {
  return {
    type: PREV_POLICY_DETAIL_CAR,
    payload: data,
  };
}
export const Create_proposal = (data) => {
  return {
    type: CREATE_CRPROPOSAL,
    payload: data,
  };
};
export const Payment_Request = (data) => {
  return {
    type: PAYMENT_CRREQUEST,
    payload: data,
  };
};
export const KYC_Status_car = (data) => {
  return {
    type: KYC_CRSTATUS,
    payload: data,
  };
};
export const Policy_PDF = (data) => {
  return {
    type: POLICY_CRPDF,
    payload: data,
  };
};
export function SaveTransID(data) {
  return {
    type: TRANS_ID_CAR,
    payload: data,
  };
}
